import LegalShell from "./LegalShell";

export default function Contact() {
  return (
    <LegalShell eyebrow="Contact" title="We'd love to hear from you.">
      <p>
        Questions about your subscription, a look that didn't land, a brand partnership,
        or a feature you wish existed — we read everything.
      </p>

      <h2>Email</h2>
      <p>
        <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a>
        <br />
        We typically respond within 1–2 business days.
      </p>

      <h2>Refunds, billing & account help</h2>
      <p>
        Include your <em>account email</em> and a short description of the issue.
        For payment-related queries, mention the approximate date and amount of the
        transaction so we can find it quickly in Razorpay.
      </p>

      <h2>Press & partnerships</h2>
      <p>
        Use the same email and mention <em>"Press"</em> or <em>"Partnership"</em> in the subject line
        and we'll route it to the right person.
      </p>

      <h2>Operating hours</h2>
      <p>
        Mon–Sat, 10:00–19:00 IST. Outside these hours we still see your email; we just take a little longer to reply.
      </p>
    </LegalShell>
  );
}
